var _defs, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResiRentSlogan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 532.08 233.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{clip-path:url(#clippath);}.cls-4{clip-path:url(#clippath-1);}.cls-5{clip-path:url(#clippath-4);}.cls-6{clip-path:url(#clippath-3);}.cls-7{clip-path:url(#clippath-2);}.cls-8{clip-path:url(#clippath-7);}.cls-9{clip-path:url(#clippath-6);}.cls-10{clip-path:url(#clippath-5);}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:url(#linear-gradient-4);}.cls-13{fill:url(#linear-gradient-2);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-5);}.cls-17{font-family:Helvetica-Light, Helvetica;font-size:24px;font-weight:300;}.cls-18{fill:#123f51;font-family:Georgia, Georgia;font-size:101.78px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 531.99,
    height: 169
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.66 61.11 19.49 35.45 86.55 3.07 86.6 7.73 86.6 7.77 13.66 61.11 13.66 61.11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -311.77,
    y1: -137.54,
    x2: -307.53,
    y2: -137.54,
    gradientTransform: "translate(-5275.16 2397.42) rotate(-180) scale(17.2 -17.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8aa12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a7635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#4a7635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#4a7635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a7635"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.81 108.6 12.19 63.63 12.2 63.63 38.02 152.76 38.02 152.76 2.81 108.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -255.69,
    y1: -182.83,
    x2: -251.45,
    y2: -182.83,
    gradientTransform: "translate(2125.6 -1409.68) scale(8.3 -8.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8aa12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f59c0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f59c0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59c0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59c0b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.66 165.55 38.02 151.94 134.8 151.94 123.12 166.29 48.66 165.55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -308.27,
    y1: -136.35,
    x2: -304.03,
    y2: -136.35,
    gradientTransform: "translate(-6899.63 3270.6) rotate(-180) scale(22.82 -22.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#289638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2b9538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.97 7.72 88.51 2.81 88.52 2.81 155.28 35.78 160.93 63.36 160.93 63.36 86.97 7.72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -270.5,
    y1: -162.34,
    x2: -266.26,
    y2: -162.34,
    gradientTransform: "translate(4804.62 -2798.11) scale(17.44 -17.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#1e1e3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e3f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "133.07 151.94 159.93 63.36 170.12 108.54 133.07 151.94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -246.06,
    y1: -181.14,
    x2: -241.82,
    y2: -181.14,
    gradientTransform: "translate(2283.14 -1475.18) scale(8.74 -8.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#931832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#931832"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 173.31,
    height: 169
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -283.95,
    y1: -156.33,
    x2: -279.71,
    y2: -156.33,
    gradientTransform: "translate(11532.16 -6428.65) rotate(-.63) scale(40.86 -40.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#123f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#093e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#123f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -282.59,
    y1: -157.05,
    x2: -278.35,
    y2: -157.05,
    gradientTransform: "translate(10072.04 -5511.56) scale(35.6 -35.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 531.99,
    height: 169
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork_17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.66,
    y: 3.07,
    width: 72.94,
    height: 58.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 2.81,
    y: 63.63,
    width: 35.21,
    height: 89.13
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 38.02,
    y: 151.94,
    width: 96.77,
    height: 14.35
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 86.97,
    y: 2.81,
    width: 73.96,
    height: 60.56
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 133.07,
    y: 63.36,
    width: 37.05,
    height: 88.57
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "123.94 166.16 123.94 166.16 49.48 166.23 2.99 108.06 19.49 35.45 86.55 3.07 153.67 35.31 170.31 107.9 123.94 166.16 123.94 166.16 123.94 166.16 170.31 107.9 153.67 35.31 86.55 3.07 19.49 35.45 2.99 108.06 49.48 166.23 49.48 166.23 49.48 166.23 123.94 166.16 123.94 166.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "86.6 7.77 86.6 7.77 159.58 61.11 134.8 151.94 38.02 151.94 13.66 61.11 86.6 7.77 86.6 7.77 86.6 7.77 13.66 61.11 38.02 151.94 134.8 151.94 159.58 61.11 86.6 7.77 86.6 7.77"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(48.02 126.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "R   esiRent")))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(201.21 160.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Conscious hosting"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(333.38 190.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "for thriving tourism"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResiRentSlogan);
export default __webpack_public_path__ + "static/media/ResiRent_slogan.639637cdee3ac7a9313bf6cee9cc6636.svg";
export { ForwardRef as ReactComponent };